import { render, staticRenderFns } from "./AdvertisingManager.vue?vue&type=template&id=c2406d08&scoped=true"
import script from "./AdvertisingManager.vue?vue&type=script&lang=js"
export * from "./AdvertisingManager.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingManager.vue?vue&type=style&index=0&id=c2406d08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2406d08",
  null
  
)

export default component.exports